export const GET_CLIENTS = "GET_CLIENTS"
export const GET_CLIENTS_FAIL = "GET_CLIENTS_FAIL"
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS"

export const GET_CLIENT_LOADING ="GET_CLIENT_LOADING"
